import React, { useState } from "react"
import { motion } from "framer-motion"
import {Search, Edit2, Trash2, MapPin, Eye, X} from 'lucide-react'
import { useGuias } from "../context/GuiasContext"
import toast from "react-hot-toast"

export default function ListarCemiterios() {
  const { cemiterios, updateCemiterio, deleteCemiterio } = useGuias()
  const [searchTerm, setSearchTerm] = useState("")
  const [editingId, setEditingId] = useState<string | null>(null)
  const [viewingCemiterio, setViewingCemiterio] = useState<any>(null)
  const [editForm, setEditForm] = useState({
    nome: "",
    codigo: "",
    endereco: "",
    latitude: "",
    longitude: ""
  })

  const filteredCemiterios = cemiterios.filter(c =>
    c.nome.toLowerCase().includes(searchTerm.toLowerCase()) ||
    c.codigo.toLowerCase().includes(searchTerm.toLowerCase()) ||
    c.endereco.toLowerCase().includes(searchTerm.toLowerCase())
  )

  const handleEdit = (cemiterio: any) => {
    setEditingId(cemiterio._id!)
    setEditForm({
      nome: cemiterio.nome,
      codigo: cemiterio.codigo,
      endereco: cemiterio.endereco,
      latitude: cemiterio.latitude || "",
      longitude: cemiterio.longitude || ""
    })
  }

  const handleSaveEdit = async (id: string) => {
    if (!editForm.nome || !editForm.codigo || !editForm.endereco) {
      toast.error("Preencha todos os campos obrigatórios")
      return
    }

    await updateCemiterio(id, editForm)
    setEditingId(null)
  }

  const handleDelete = async (id: string, nome: string) => {
    if (window.confirm(`Deseja realmente excluir o cemitério "${nome}"?`)) {
      await deleteCemiterio(id)
    }
  }

  return (
    <div className="space-y-6">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="bg-white rounded-xl shadow-lg p-6 border border-gray-200"
      >
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-2xl font-bold text-gray-800">Cemitérios Cadastrados</h2>
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <MapPin className="w-4 h-4" />
            <span>{cemiterios.length} cemitério(s)</span>
          </div>
        </div>

        {/* Busca */}
        <div className="relative mb-6">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
          <input
            type="text"
            placeholder="Buscar por nome, código ou endereço..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#004161] focus:border-transparent"
          />
        </div>

        {/* Tabela Desktop */}
        <div className="hidden md:block overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="bg-gray-50 border-b border-gray-200">
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Código</th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Nome</th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Endereço</th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Localização</th>
                <th className="px-4 py-3 text-center text-sm font-semibold text-gray-700">Ações</th>
              </tr>
            </thead>
            <tbody>
              {filteredCemiterios.length === 0 ? (
                <tr>
                  <td colSpan={5} className="px-4 py-8 text-center text-gray-500">
                    Nenhum cemitério cadastrado
                  </td>
                </tr>
              ) : (
                filteredCemiterios.map((cemiterio) => (
                  <tr key={cemiterio._id} className="border-b border-gray-100 hover:bg-gray-50">
                    {editingId === cemiterio._id ? (
                      <>
                        <td className="px-4 py-3">
                          <input
                            type="text"
                            value={editForm.codigo}
                            onChange={(e) => setEditForm({ ...editForm, codigo: e.target.value })}
                            className="w-full px-2 py-1 border border-gray-300 rounded text-sm"
                            placeholder="Código"
                          />
                        </td>
                        <td className="px-4 py-3">
                          <input
                            type="text"
                            value={editForm.nome}
                            onChange={(e) => setEditForm({ ...editForm, nome: e.target.value })}
                            className="w-full px-2 py-1 border border-gray-300 rounded text-sm"
                            placeholder="Nome"
                          />
                        </td>
                        <td className="px-4 py-3">
                          <input
                            type="text"
                            value={editForm.endereco}
                            onChange={(e) => setEditForm({ ...editForm, endereco: e.target.value })}
                            className="w-full px-2 py-1 border border-gray-300 rounded text-sm"
                            placeholder="Endereço"
                          />
                        </td>
                        <td className="px-4 py-3">
                          <div className="space-y-1">
                            <input
                              type="text"
                              value={editForm.latitude}
                              onChange={(e) => setEditForm({ ...editForm, latitude: e.target.value })}
                              className="w-full px-2 py-1 border border-gray-300 rounded text-xs"
                              placeholder="Latitude"
                            />
                            <input
                              type="text"
                              value={editForm.longitude}
                              onChange={(e) => setEditForm({ ...editForm, longitude: e.target.value })}
                              className="w-full px-2 py-1 border border-gray-300 rounded text-xs"
                              placeholder="Longitude"
                            />
                          </div>
                        </td>
                        <td className="px-4 py-3">
                          <div className="flex items-center justify-center gap-2">
                            <button
                              onClick={() => handleSaveEdit(cemiterio._id!)}
                              className="px-3 py-1 bg-green-600 text-white text-xs rounded hover:bg-green-700"
                            >
                              Salvar
                            </button>
                            <button
                              onClick={() => setEditingId(null)}
                              className="px-3 py-1 bg-gray-600 text-white text-xs rounded hover:bg-gray-700"
                            >
                              Cancelar
                            </button>
                          </div>
                        </td>
                      </>
                    ) : (
                      <>
                        <td className="px-4 py-3 text-sm text-gray-700 font-medium">{cemiterio.codigo}</td>
                        <td className="px-4 py-3 text-sm text-gray-900">{cemiterio.nome}</td>
                        <td className="px-4 py-3 text-sm text-gray-600">{cemiterio.endereco}</td>
                        <td className="px-4 py-3 text-xs text-gray-500">
                          {cemiterio.latitude && cemiterio.longitude ? (
                            <div className="flex flex-col gap-1">
                              <span>Lat: {cemiterio.latitude}</span>
                              <span>Long: {cemiterio.longitude}</span>
                            </div>
                          ) : (
                            <span className="text-gray-400">Não informado</span>
                          )}
                        </td>
                        <td className="px-4 py-3">
                          <div className="flex items-center justify-center gap-2">
                            <button
                              onClick={() => setViewingCemiterio(cemiterio)}
                              className="p-2 text-teal-600 hover:bg-teal-50 rounded-lg transition-colors"
                              title="Visualizar"
                            >
                              <Eye className="w-4 h-4" />
                            </button>
                            <button
                              onClick={() => handleEdit(cemiterio)}
                              className="p-2 text-blue-600 hover:bg-blue-50 rounded-lg transition-colors"
                              title="Editar"
                            >
                              <Edit2 className="w-4 h-4" />
                            </button>
                            <button
                              onClick={() => handleDelete(cemiterio._id!, cemiterio.nome)}
                              className="p-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                              title="Excluir"
                            >
                              <Trash2 className="w-4 h-4" />
                            </button>
                          </div>
                        </td>
                      </>
                    )}
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* Cards Mobile */}
        <div className="md:hidden space-y-4">
          {filteredCemiterios.length === 0 ? (
            <div className="text-center py-8 text-gray-500">
              Nenhum cemitério cadastrado
            </div>
          ) : (
            filteredCemiterios.map((cemiterio) => (
              <div key={cemiterio._id} className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                {editingId === cemiterio._id ? (
                  <div className="space-y-3">
                    <input
                      type="text"
                      value={editForm.codigo}
                      onChange={(e) => setEditForm({ ...editForm, codigo: e.target.value })}
                      className="w-full px-3 py-2 border border-gray-300 rounded text-sm"
                      placeholder="Código"
                    />
                    <input
                      type="text"
                      value={editForm.nome}
                      onChange={(e) => setEditForm({ ...editForm, nome: e.target.value })}
                      className="w-full px-3 py-2 border border-gray-300 rounded text-sm"
                      placeholder="Nome"
                    />
                    <input
                      type="text"
                      value={editForm.endereco}
                      onChange={(e) => setEditForm({ ...editForm, endereco: e.target.value })}
                      className="w-full px-3 py-2 border border-gray-300 rounded text-sm"
                      placeholder="Endereço"
                    />
                    <input
                      type="text"
                      value={editForm.latitude}
                      onChange={(e) => setEditForm({ ...editForm, latitude: e.target.value })}
                      className="w-full px-3 py-2 border border-gray-300 rounded text-sm"
                      placeholder="Latitude (opcional)"
                    />
                    <input
                      type="text"
                      value={editForm.longitude}
                      onChange={(e) => setEditForm({ ...editForm, longitude: e.target.value })}
                      className="w-full px-3 py-2 border border-gray-300 rounded text-sm"
                      placeholder="Longitude (opcional)"
                    />
                    <div className="flex gap-2">
                      <button
                        onClick={() => handleSaveEdit(cemiterio._id!)}
                        className="flex-1 px-4 py-2 bg-green-600 text-white text-sm rounded hover:bg-green-700"
                      >
                        Salvar
                      </button>
                      <button
                        onClick={() => setEditingId(null)}
                        className="flex-1 px-4 py-2 bg-gray-600 text-white text-sm rounded hover:bg-gray-700"
                      >
                        Cancelar
                      </button>
                    </div>
                  </div>
                ) : (
                  <>
                    <div className="mb-3">
                      <p className="text-xs text-gray-500 mb-1">Código</p>
                      <p className="font-semibold text-gray-900">{cemiterio.codigo}</p>
                    </div>
                    <div className="mb-3">
                      <p className="text-xs text-gray-500 mb-1">Nome</p>
                      <p className="text-gray-900">{cemiterio.nome}</p>
                    </div>
                    <div className="mb-3">
                      <p className="text-xs text-gray-500 mb-1">Endereço</p>
                      <p className="text-sm text-gray-600">{cemiterio.endereco}</p>
                    </div>
                    {cemiterio.latitude && cemiterio.longitude && (
                      <div className="mb-3">
                        <p className="text-xs text-gray-500 mb-1">Localização</p>
                        <p className="text-xs text-gray-600">Lat: {cemiterio.latitude}</p>
                        <p className="text-xs text-gray-600">Long: {cemiterio.longitude}</p>
                      </div>
                    )}
                    <div className="flex gap-2 pt-2 border-t border-gray-200">
                      <button
                        onClick={() => setViewingCemiterio(cemiterio)}
                        className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-teal-600 text-white text-sm rounded hover:bg-teal-700"
                      >
                        <Eye className="w-4 h-4" />
                        Ver
                      </button>
                      <button
                        onClick={() => handleEdit(cemiterio)}
                        className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-blue-600 text-white text-sm rounded hover:bg-blue-700"
                      >
                        <Edit2 className="w-4 h-4" />
                        Editar
                      </button>
                      <button
                        onClick={() => handleDelete(cemiterio._id!, cemiterio.nome)}
                        className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-red-600 text-white text-sm rounded hover:bg-red-700"
                      >
                        <Trash2 className="w-4 h-4" />
                        Excluir
                      </button>
                    </div>
                  </>
                )}
              </div>
            ))
          )}
        </div>
      </motion.div>

      {/* Modal de Visualização */}
      {viewingCemiterio && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            className="bg-white rounded-xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto"
          >
            <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between">
              <h3 className="text-xl font-bold text-gray-800">Detalhes do Cemitério</h3>
              <button
                onClick={() => setViewingCemiterio(null)}
                className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
              >
                <X className="w-5 h-5 text-gray-500" />
              </button>
            </div>

            <div className="p-6 space-y-6">
              {/* Informações Básicas */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="bg-gray-50 p-4 rounded-lg">
                  <p className="text-xs text-gray-500 mb-1">Código</p>
                  <p className="text-lg font-semibold text-gray-900">{viewingCemiterio.codigo}</p>
                </div>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <p className="text-xs text-gray-500 mb-1">Nome do Cemitério</p>
                  <p className="text-lg font-semibold text-gray-900">{viewingCemiterio.nome}</p>
                </div>
              </div>

              <div className="bg-gray-50 p-4 rounded-lg">
                <p className="text-xs text-gray-500 mb-1">Endereço</p>
                <p className="text-base text-gray-900">{viewingCemiterio.endereco}</p>
              </div>

              {/* Coordenadas */}
              {viewingCemiterio.latitude && viewingCemiterio.longitude ? (
                <>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="bg-gray-50 p-4 rounded-lg">
                      <p className="text-xs text-gray-500 mb-1">Latitude</p>
                      <p className="text-base font-mono text-gray-900">{viewingCemiterio.latitude}</p>
                    </div>
                    <div className="bg-gray-50 p-4 rounded-lg">
                      <p className="text-xs text-gray-500 mb-1">Longitude</p>
                      <p className="text-base font-mono text-gray-900">{viewingCemiterio.longitude}</p>
                    </div>
                  </div>

                  {/* Mapa do Google */}
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <p className="text-sm font-semibold text-gray-700 mb-3 flex items-center gap-2">
                      <MapPin className="w-4 h-4" />
                      Localização no Mapa
                    </p>
                    <div className="w-full h-96 rounded-lg overflow-hidden border border-gray-300">
                      <iframe
                        src={`https://www.google.com/maps?q=${viewingCemiterio.latitude},${viewingCemiterio.longitude}&z=15&output=embed`}
                        width="100%"
                        height="100%"
                        style={{ border: 0 }}
                        allowFullScreen
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                      />
                    </div>
                    <div className="mt-2 flex gap-2">
                      <a
                        href={`https://www.google.com/maps?q=${viewingCemiterio.latitude},${viewingCemiterio.longitude}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-sm text-blue-600 hover:text-blue-700 underline"
                      >
                        Abrir no Google Maps
                      </a>
                    </div>
                  </div>
                </>
              ) : (
                <div className="bg-yellow-50 border border-yellow-200 p-4 rounded-lg">
                  <p className="text-sm text-yellow-800">
                    <MapPin className="w-4 h-4 inline mr-2" />
                    Coordenadas de geolocalização não informadas para este cemitério.
                  </p>
                </div>
              )}

              {/* Botão Fechar */}
              <div className="flex justify-end pt-4 border-t border-gray-200">
                <button
                  onClick={() => setViewingCemiterio(null)}
                  className="px-6 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors"
                >
                  Fechar
                </button>
              </div>
            </div>
          </motion.div>
        </div>
      )}
    </div>
  )
}
